












import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
    props: {
        position: {
            type: String,
            default: 'top'
        },
        name: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        }
    },
    /*data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },*/
    setup() {

    },
})
